export const APEX_ACCOUNT_STATUS_VIEW = {
  DRAFT_VIEW: 'DraftView',
  PENDING_VIEW: 'PendingView',
  ADVISOR_REVIEW_VIEW: 'AdvisorReviewView',
  APPEAL_VIEW: 'AppealView',
  APPEAL_PENDING_VIEW: 'AppealPendingView',
  ERROR_VIEW: 'ErrorView',
  REJECTED_VIEW: 'RejectedView',
} as const;

export const UPDATE_APEX_ACCOUNT_STATUS = 'STATUS_VIEW.UPDATE_APEX_ACCOUNT_STATUS';
